import { Globe, ArrowRight } from 'lucide-react'
import { featureLabel } from './constants'

export interface ProjectCostData {
  clientId: number
  clientName: string
  clientDomain: string
  totalCalls: number
  totalCredits: number
  estimatedCost: number
  features: Array<{
    action: string
    calls: number
    credits: number
    estimatedCost: number
    unitCost: number
  }>
}

interface ProjectCostCardProps {
  project: ProjectCostData
  onClick: () => void
}

export default function ProjectCostCard({ project, onClick }: ProjectCostCardProps) {
  const topFeature = project.features.length > 0
    ? project.features.reduce((a, b) => (a.estimatedCost > b.estimatedCost ? a : b))
    : null

  return (
    <button
      onClick={onClick}
      className="w-full bg-white border border-[#E2E4ED] rounded-xl p-5 text-left transition-all hover:border-indigo-400 hover:shadow-md"
    >
      <div className="flex items-start justify-between">
        <div className="flex items-center gap-3">
          <div className="rounded-lg bg-indigo-500/10 p-2.5">
            <Globe className="h-5 w-5 text-indigo-600" />
          </div>
          <div>
            <h3 className="font-semibold text-[#1B2559]">{project.clientName}</h3>
            <p className="text-sm text-[#8B8FA7]">{project.clientDomain}</p>
          </div>
        </div>
        <ArrowRight className="h-4 w-4 text-[#8B8FA7]" />
      </div>

      <div className="mt-4 grid grid-cols-3 gap-3">
        <div>
          <p className="text-xs text-[#8B8FA7]">Coût estimé</p>
          <p className="text-lg font-semibold text-[#1B2559]">${project.estimatedCost.toFixed(4)}</p>
        </div>
        <div>
          <p className="text-xs text-[#8B8FA7]">Appels API</p>
          <p className="text-lg font-semibold text-[#1B2559]">{project.totalCalls.toLocaleString()}</p>
        </div>
        <div>
          <p className="text-xs text-[#8B8FA7]">Feature principale</p>
          <p className="text-sm font-medium text-indigo-600">
            {topFeature ? featureLabel(topFeature.action) : '-'}
          </p>
        </div>
      </div>

      {project.features.length > 1 && (
        <p className="mt-3 text-xs text-[#8B8FA7]">
          {project.features.length} features actives — cliquer pour le détail
        </p>
      )}
    </button>
  )
}
